<template>
  <div class="basket-item" v-if="item_title">
    <div class="basket-item__header">
      <span
        v-if="
          prop_parking_cartitem &&
          prop_parking_cartitem.product_display_name &&
          setbrandid != 'RDU' &&
          setbrandid != 'NWI' &&
          setbrandid != 'HER'
        "
        class="basket-item__title"
        >{{ replaceHtmlEntities(getrans(prop_parking_cartitem.product_display_name)) }}</span
      >
      <span v-else class="basket-item__title">{{ replaceHtmlEntities(getrans(item_title)) }}</span>
      <span class="basket-item__price">
        {{ currency_formatter(parkingDisplayTotal) }}
      </span>
    </div>

    <div class="basket-item__dates">
      <div class="basket-item__block">
        <span class="basket-item__start_date"
          ><i class="far fa-calendar"></i>&nbsp;{{ date_formatter(item_start_date_m) }}&nbsp;</span
        >
        <span class="basket-item__start_time"
          ><i class="far fa-clock"></i>&nbsp;{{ item_start_time_m }}&nbsp;</span
        >
      </div>

      <span class="basket-item__start_to">&nbsp;{{ getrans("to") }}&nbsp;</span>

      <div class="basket-item__block">
        <span class="basket-item__end_date"
          ><i class="far fa-calendar"></i>&nbsp;{{ date_formatter(item_end_date_m) }}&nbsp;</span
        >
        <span class="basket-item__end_time"
          ><i class="far fa-clock"></i>&nbsp;{{ item_end_time_m }}&nbsp;</span
        >
      </div>
    </div>
  </div>

  <div class="basket-item" v-if="prop_lounge_cartitem">
    <div class="basket-item__header">
      <span class="basket-item__title">{{
        getrans(prop_lounge_cartitem.product_name)
      }}</span>
      <span class="basket-item__price">
        {{ currency_formatter(loungeDisplayTotal) }}</span
      >
    </div>
    <div class="basket-item__dates">
      <div class="basket-item__block basket-item__block--no-end-date">
        <span class="basket-item__start_date"
          ><i class="far fa-calendar"></i>
          {{ date_formatter(prop_lounge_cartitem.date_selected_display) }}</span
        >
        <span class="basket-item__start_time"
          ><i class="far fa-clock"></i>
          {{ prop_lounge_cartitem.time_selected }}</span
        >

        <span class="basket-item__total-people"
          ><i class="fas fa-user"></i>
          {{
            Number(prop_lounge_cartitem.ADL) +
            Number(prop_lounge_cartitem.CHD) +
            Number(prop_lounge_cartitem.INF)
          }}</span
        >
      </div>
    </div>
    <div class="basket-item__age-groups">
      <span
        class="basket-item__age-group"
        v-if="Number(prop_lounge_cartitem.ADL) > 0"
        >{{ getrans(text_adults) }}: {{ prop_lounge_cartitem.ADL }}</span
      >
      <span
        class="basket-item__age-group"
        v-if="Number(prop_lounge_cartitem.CHD) > 0"
        >{{ getrans(text_children) }}: {{ prop_lounge_cartitem.CHD }}</span
      >
      <span
        class="basket-item__age-group"
        v-if="Number(prop_lounge_cartitem.INF) > 0"
        >{{ getrans(text_infants) }}: {{ prop_lounge_cartitem.INF }}</span
      >
    </div>
  </div>

  <!-- {{adhoc_lounge_cart}} -->
  <template v-for="(cartitem_item, i) in adhoc_lounge_cart" :key="'ADHOC-' + i">
    <template v-if="cartitem_item !== null && cartitem_item.pr_type === 'S'"
      ><div class="basket-item">
        <div class="basket-item__header">
          <span class="basket-item__title">{{
            getrans(cartitem_item.pr_name)
          }}</span>

          <span class="basket-item__price">{{
            currency_formatter(cartitem_item.pr_price)
          }}</span>
        </div>
      </div>
    </template>
    <template v-else-if="cartitem_item !== null">
      <template
        v-for="(multi_item, j) in cartitem_item"
        :key="'ADHOC-cartitem_item-' + j"
        ><div class="basket-item">
          <div class="basket-item__header">
            <span class="basket-item__title">{{ multi_item.pr_name }}</span>

            <span class="basket-item__price">{{
              currency_formatter(multi_item.pr_price)
            }}</span>
          </div>
        </div>
      </template>
    </template>
  </template>

  <!-- FASTTRACK -->
  <template v-if="prop_fasttrack_cartitem">
    <div class="basket-item"
      v-for="(prop_fasttrack_cartitem_item, i) in prop_fasttrack_cartitem"
      :key="'FTT-' + i"
    >
      <div class="basket-item__header">
        <span class="basket-item__title">{{
          getrans(prop_fasttrack_cartitem_item.product_name)
        }}</span>
        <span
          class="basket-item__price">
          
          {{
            currency_formatter(fttDisplayTotalFor(prop_fasttrack_cartitem_item))
          }}
        </span>
      </div>
      <div class="basket-item__dates">
        <div class="basket-item__block basket-item__block--no-end-date">
          <span class="basket-item__start_date"
            ><i class="far fa-calendar"></i>
            {{ date_formatter(prop_fasttrack_cartitem_item.date_selected_display) }}</span
          >
          <span class="basket-item__start_time"
            ><i class="far fa-clock"></i>
            {{ prop_fasttrack_cartitem_item.time_selected }}</span
          >

          <span class="basket-item__total-people"
            ><i class="fas fa-user"></i>
            {{
              Number(prop_fasttrack_cartitem_item.ADL) +
              Number(prop_fasttrack_cartitem_item.CHD) +
              Number(prop_fasttrack_cartitem_item.INF)
            }}</span
          >
        </div>
      </div>

      <div class="basket-item__age-groups" v-show="setbrandid !== 'BHX'">
        <span
          class="basket-item__age-group"
          v-if="Number(prop_fasttrack_cartitem_item.ADL) > 0"
          >{{ getrans("Adults") }}: {{ prop_fasttrack_cartitem_item.ADL }}</span
        >
        <span
          class="basket-item__age-group"
          v-if="Number(prop_fasttrack_cartitem_item.CHD) > 0"
          >{{ getrans("Children") }}:
          {{ prop_fasttrack_cartitem_item.CHD }}</span
        >
        <span
          class="basket-item__age-group"
          v-if="Number(prop_fasttrack_cartitem_item.INF) > 0"
          >{{ getrans("Infants") }}:
          {{ prop_fasttrack_cartitem_item.INF }}</span
        >
      </div>
    </div>
  </template>

  <!-- {{adhoc_cart}} -->
  <template v-for="(cartitem_item, i) in adhoc_cart" :key="'ADHOC-' + i">
    <template v-if="cartitem_item !== null && cartitem_item.pr_type === 'S'"
      ><div class="basket-item">
        <div class="basket-item__header">
          <span class="basket-item__title">{{
            getrans(cartitem_item.pr_name)
          }}</span>

          <span class="basket-item__price">{{
            currency_formatter(cartitem_item.pr_price)
          }}</span>
        </div>
      </div>
    </template>
    <template v-else-if="cartitem_item !== null">
      <template
        v-for="(multi_item, j) in cartitem_item"
        :key="'ADHOC-cartitem_item-' + j"
        ><div class="basket-item">
          <div class="basket-item__header">
            <span class="basket-item__title">{{ multi_item.pr_name }}</span>

            <span class="basket-item__price">{{
              currency_formatter(multi_item.pr_price)
            }}</span>
          </div>
        </div>
      </template>
    </template>
  </template>

  <!-- COACH -->
  <div class="basket-item" v-if="prop_coach_cartitem">
    <div class="basket-item__header">
      <span class="basket-item__title">{{
        getrans(prop_coach_cartitem.product_name)
      }}</span>
      <span class="basket-item__price" 
        > 
        {{
            currency_formatter(coachDisplayTotal)
          }}
      </span>
    </div>
    <div class="basket-item__dates">
      <div class="basket-item__block basket-item__block--no-end-date">
        <span class="basket-item__start_date"
          ><i class="far fa-calendar"></i>
          {{
            date_formatter(prop_coach_cartitem.date_selected_display)
          }}</span
        >

        <!-- {{prop_coach_cartitem}} -->

        <span class="basket-item__start_time"
          ><i class="far fa-clock"></i>
          {{ prop_coach_cartitem.time_selected }}</span
        >

        <span class="basket-item__total-people"
          ><i class="fas fa-bus"></i>
          {{ prop_coach_cartitem.coach_selected.length }}</span
        >
      </div>
    </div>

    <div class="basket-item__age-groups">
      <span
        class="basket-item__age-group"
        v-if="Number(prop_coach_cartitem.ADL) > 0"
        >{{ getrans("Adults") }}: {{ prop_coach_cartitem.ADL }}</span
      >
      <span
        class="basket-item__age-group"
        v-if="Number(prop_coach_cartitem.CHD) > 0"
        >{{ getrans("Children") }}: {{ prop_coach_cartitem.CHD }}</span
      >
      <span
        class="basket-item__age-group"
        v-if="Number(prop_coach_cartitem.INF) > 0"
        >{{ getrans("Infants") }}: {{ prop_coach_cartitem.INF }}</span
      >
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
const axios = require("axios");
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
const crypto = require("crypto");
import { getBrandConfig } from "../brand/brand.config.js";
export default {
  name: "BasketItemConfirmation",
  props: {
    prop_parking_cartitem: undefined,
    prop_fasttrack_cartitem: undefined,
    prop_lounge_cartitem: undefined,
    prop_coach_cartitem: undefined,
    prop_atr_cartitem: undefined,
    tot_price: undefined,
    item_price: undefined,
    item_title: undefined,
    item_start_date: undefined,
    item_start_time: undefined,
    item_end_date: undefined,
    item_end_time: undefined,
    lang: undefined,
    translations: undefined,
    final_amount_paid_tot: undefined,
    lounge_total_value: undefined,
    ftt_total_value: undefined,
    cpk_total_value: undefined,
    coach_total_value: undefined,
  },
  data() {
    return {
      text_adults: "Adults",
      text_children: "Children",
      text_infants: "Infants",
      setbrandid: "",
      currency: "",
      item_start_date_m: "",
      item_start_time_m: "",
      item_end_date_m: "",
      item_end_time_m: "",
      lngtotal: "0",
      cpktotal: "0",
      ftttotal: "0",
      coatotal: "0",
      adhoc_cart: [],
      adhoc_lounge_cart: [],
    };
  },
  computed: {
    usFormatBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_US_FORMAT);
      } catch (e) {
        console.error("Failed to parse VUE_APP_US_FORMAT:", e);
        return [];
      }
    },
    loungeDisplayTotal() {
      if (Number(this.final_amount_paid_tot) === 0) {
        return "0.00";
      } 

      const lngTotal = Number(
        this.lounge_total_value !== undefined && this.lounge_total_value !== null
          ? this.lounge_total_value
          : this.lngtotal
      );
      if (lngTotal > 0) {
        return lngTotal.toFixed(2);
      }

      return Number(this.prop_lounge_cartitem?.loungesubtotal || 0).toFixed(2);
    },
    parkingDisplayTotal() {
      const cpkTotal = this.normalizeMoneyValue(this.cpk_total_value);
      if (cpkTotal !== null) {
        return cpkTotal.toFixed(2);
      }

      if (Number(this.cpktotal) > 0) {
        return Number(this.cpktotal).toFixed(2);
      }

      if (this.tot_price) {
        return parseFloat(this.tot_price).toFixed(2);
      }

      return Number(this.prop_parking_cartitem?.ordertotal || 0).toFixed(2);
    },
    fttDisplayTotal() {
      if (Number(this.final_amount_paid_tot) === 0) {
        return "0.00";
      }

      const propFttTotal = this.normalizeFttTotal(this.ftt_total_value);
      if (propFttTotal !== null) {
        return propFttTotal.toFixed(2);
      }

      const fttTotal = Number(this.ftttotal);
      if (fttTotal > 0) {
        return fttTotal.toFixed(2);
      }

      const fasttrackSubtotal = Array.isArray(this.prop_fasttrack_cartitem)
        ? this.prop_fasttrack_cartitem.reduce(
            (sum, item) => sum + Number(item?.fasttracksubtotal || 0),
            0
          )
        : Number(this.prop_fasttrack_cartitem?.fasttracksubtotal || 0);

      return fasttrackSubtotal.toFixed(2);
    },
    coachDisplayTotal() {
      if (Number(this.final_amount_paid_tot) === 0) {
        return "0.00";
      }

      const coachTotal = this.normalizeMoneyValue(this.coach_total_value);
      if (coachTotal !== null) {
        return coachTotal.toFixed(2);
      }

      if (Number(this.coatotal) > 0) {
        return Number(this.coatotal).toFixed(2);
      }

      return Number(this.prop_coach_cartitem?.coachsubtotal || 0).toFixed(2);
    },
  },
  methods: {
    replaceHtmlEntities(str) {
      if (!str) return '';
      return str.replace(/&#39;/g, "'");
    },
    date_formatter(string) {
      if (process.env.VUE_APP_DATE_SEPARATOR_DOT && JSON.parse(process.env.VUE_APP_DATE_SEPARATOR_DOT).includes(this.setbrandid)) {
        return string.replaceAll('/', '.');
      }
      return string;
    },
    currency_formatter(money) {
      if (!money) return;
      const brandConfig = getBrandConfig(this.setbrandid);
      if (brandConfig.features?.currencyAfterValue) {
        money = money.toString().replace(".", ",");
        return money + " " + this.currency;
      }
      return this.currency + " " + money;
    },
    normalizeFttTotal(value) {
      if (value === undefined || value === null) return null;
      if (typeof value === "string") {
        try {
          value = JSON.parse(value);
        } catch (e) {
          const parsed = parseFloat(value);
          return Number.isNaN(parsed) ? null : parsed;
        }
      }
      if (typeof value === "object") {
        let totalAmount = 0;
        Object.keys(value).forEach((key) => {
          if (
            value[key] &&
            typeof value[key] === "object" &&
            value[key].finalamount !== undefined
          ) {
            totalAmount += parseFloat(value[key].finalamount) || 0;
          }
        });
        return totalAmount;
      }
      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? null : parsed;
    },
    normalizeMoneyValue(value) {
      if (value === undefined || value === null) return null;
      if (typeof value === "string") {
        const parsed = parseFloat(value);
        return Number.isNaN(parsed) ? null : parsed;
      }
      if (typeof value === "number") {
        return Number.isNaN(value) ? null : value;
      }
      return null;
    },
    parseFttTotalMap(value) {
      if (value === undefined || value === null) return null;
      if (typeof value === "string") {
        try {
          return JSON.parse(value);
        } catch (e) {
          return null;
        }
      }
      if (typeof value === "object") return value;
      return null;
    },
    extractFttAmount(value) {
      if (value === undefined || value === null) return null;
      if (typeof value === "object" && value.finalamount !== undefined) {
        const parsed = parseFloat(value.finalamount);
        return Number.isNaN(parsed) ? null : parsed;
      }
      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? null : parsed;
    },
    fttDisplayTotalFor(item) {
      if (Number(this.final_amount_paid_tot) === 0) {
        return "0.00";
      }

      const map = this.parseFttTotalMap(this.ftt_total_value);
      if (map && item) {
        const pid = item.product_id;
        const key = "ftt" + pid;
        const amount = this.extractFttAmount(
          map[key] ?? map[pid] ?? map[String(pid)]
        );
        if (amount !== null) {
          return amount.toFixed(2);
        }
      }

      return Number(item?.fasttracksubtotal || 0).toFixed(2);
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);
      return this.translations[ss] || string;
    },
    getbranded() {
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/gtbrnslg.php",
          "",
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response.data.slug);
          console.log(response.data.currency);
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.currency = response.data.currency;

            if (response.data.slug == "HER") {
              this.text_adults = "Standard (Ages 6+)";
              this.text_children = "Child (0-5)";
            }

            if (response.data.slug == "FMM") {
              this.text_adults = "People";
            }

            if (
              process.env.VUE_APP_CURRENCY_EURO && JSON.parse(process.env.VUE_APP_CURRENCY_EURO).includes(response.data.slug)
            ) {
              this.currency = "€";
            }
            if (
              this.usFormatBrands.indexOf(this.setbrandid) > -1
            ) {
              var farray = this.item_start_date.split("/");
              console.log("item_start_date", this.item_start_date);
              this.item_start_date_m =
                farray[1] + "/" + farray[0] + "/" + farray[2];
              console.log("item_start_date_m", this.item_start_date_m);
              this.item_start_time_m = this.formatTime(this.item_start_time);
              var earray = this.item_end_date.split("/");
              this.item_end_date_m =
                earray[1] + "/" + earray[0] + "/" + earray[2];
              this.item_end_time_m = this.formatTime(this.item_end_time);
            } else {
              this.item_start_date_m = this.item_start_date;
              this.item_start_time_m = this.item_start_time;
              this.item_end_date_m = this.item_end_date;
              this.item_end_time_m = this.item_end_time;
            }

            //this.loadTranslations();
            //this.getBrandData();
          }
        });
    },
    formatTime(timeString) {
      let [hourString, minute] = timeString.split(":");
      let hour = +hourString % 24;
      return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
    },
    async get_rez_data_k()
    {
      if (typeof encryptStorage.getItem("rez_dev_k") === "undefined") 
      {
        let _this = this;
        await axios.get('https://devhub.rezcomm.com/hubapmydbauth/livedata/index.php')
        .then(response => {

        const key = 'XwB?au@qy*^y!r6R&wV8fVuSXmGKf3Sn';
        const encryptedData = response.data;
        let dec = _this.decrypt_custom(key, encryptedData);
        
        encryptStorage.setItem("rez_dev_k",dec);
        
             
        })
        .then(() => {
          _this.getbranded();
        }
        )
        .catch(error => {
        console.error(error);
        });
        }
        else
        {
          this.getbranded();
        }
    },
    decrypt_custom(key, data) {
      
      const decodedData = Buffer.from(data, 'base64').toString('utf8');
        const parts = decodedData.split('::');
    
        // Extract IV
        key = Buffer.from(parts[0]);
        let iv = Buffer.from(parts[2], 'hex');
    
        // Extract encrypted data
        const encryptedData = Buffer.from(parts[1], 'base64');
    
        // Create decipher object with correct IV and key
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
    
        // Update decryption with encrypted data
        let decrypted = decipher.update(encryptedData);
    
        // Finalize the decryption
        decrypted = Buffer.concat([decrypted, decipher.final()]);
    
        return decrypted.toString('utf8');
}    
  },
  mounted() {
    //this.setbrandid = "BOS";this.currency="$";
    //  console.log(encryptStorage.getItem("finaltotalvalue_cpk"));
    // console.log('item_title',this.item_title);
    // console.log('prop_parking_cartitem',this.prop_parking_cartitem);
    // console.log('prop_lounge_cartitem',this.prop_lounge_cartitem.loungesubtotal);
    //  console.log('prop_fasttrack_cartitem',this.prop_fasttrack_cartitem);
    console.log('finaltotalvalue_lng',encryptStorage.getItem("finaltotalvalue_lng"));

    if (
      encryptStorage.getItem("finaltotalvalue_lng") !== undefined &&
      encryptStorage.getItem("finaltotalvalue_lng") !== null
    ) {
      this.lngtotal = encryptStorage.getItem("finaltotalvalue_lng");

    }

    if (
      encryptStorage.getItem("finaltotalvalue_cpk") !== undefined &&
      encryptStorage.getItem("finaltotalvalue_cpk") !== null
    ) {
      this.cpktotal = encryptStorage.getItem("finaltotalvalue_cpk");
    }
    console.log("CONFIRM BasketItem CPK", {
      tot_price: this.tot_price,
      cpk_total_value: this.cpk_total_value,
      cpktotal: this.cpktotal,
      ordertotal: this.prop_parking_cartitem?.ordertotal,
      cartitem: this.prop_parking_cartitem,
    });

    if (
      this.coach_total_value === undefined ||
      this.coach_total_value === null
    ) {
      if (
        encryptStorage.getItem("finaltotalvalue_chp") !== undefined &&
        encryptStorage.getItem("finaltotalvalue_chp") !== null
      ) {
        this.coatotal = encryptStorage.getItem("finaltotalvalue_chp");
      }
    }

    if (
      this.ftt_total_value === undefined ||
      this.ftt_total_value === null
    ) {
      if (
        encryptStorage.getItem("finaltotalvalue_ftt") !== undefined &&
        encryptStorage.getItem("finaltotalvalue_ftt") !== null
      ) {
        let fttData = encryptStorage.getItem("finaltotalvalue_ftt");
        this.ftttotal = this.normalizeFttTotal(fttData) || 0;
      }
    }

    this.get_rez_data_k();
    if (!this.item_start_date) {
      return;
    }
    console.log("lngtotal", this.lngtotal);
    var farray = this.item_start_date.split("/");
    this.item_start_date_m = farray[1] + "/" + farray[0] + "/" + farray[2];
    this.item_start_time_m = this.formatTime(this.item_start_time);
    var earray = this.item_end_date.split("/");
    this.item_end_date_m = earray[1] + "/" + earray[0] + "/" + earray[2];
    this.item_end_time_m = this.formatTime(this.item_end_time);

    //   console.log("window.location.hostname", window.location.hostname);
    // if(this.setbrandid=="")
    // {
    //   this.setbrandid = "BOS";this.currency="$";
    //   if (window.location.hostname == "herv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "HER";this.currency="€";
    //   }
    //   if (window.location.hostname == "nwiv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "NWI";this.currency="£";
    //   }
    //   if (window.location.hostname == "rduv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "RDU";this.currency="$";
    //   }
    //   if (window.location.hostname == "bosv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "BOS";this.currency="$";
    //   }
    // }

    this.adhoc_cart = encryptStorage.getItem("adhoc_cart");
    window.addEventListener(
      "update_basket",
      () => {
        this.adhoc_cart = encryptStorage.getItem("adhoc_cart");
      },
      false
    );

    this.adhoc_lounge_cart = encryptStorage.getItem("adhoc_lounge_cart");
    sessionStorage.setItem("adhoc_lounge_cart_temp", null);
    this.last_lounge_search = encryptStorage.getItem("last_lounge_search");
    window.addEventListener(
      "update_basket",
      () => {
        this.adhoc_lounge_cart = encryptStorage.getItem("adhoc_lounge_cart");
        sessionStorage.setItem("adhoc_lounge_cart_temp", null);
        this.last_lounge_search = encryptStorage.getItem("last_lounge_search");
      },
      false
    );
  },
};
</script>

<style lang="scss">
.basket-item + .basket-item {
  border-top: 1px solid #ddd;
  .basket-item__header {
    //margin: 0.825rem 0 0rem;
  }
}

.basket-item {
  padding: 0.825rem 0;

  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__title {
    // font-weight: bold;
    // color: #1a2a40;
    // font-size: 1.125rem;
    font-family: var(--details_headings_font_family, inherit);
    font-size: var(--details_headings_font_size, 1.125rem);
    font-weight: var(--details_headings_font_weight, bold);
    color: var(--details_headings_font_color, #1a2a40);
  }

  &__dates {
    display: flex;
    justify-content: flex-start;
    font-size: 0.925rem;
    color: #707070;
    font-weight: bold;
    margin: 0.5rem 0 0;
    gap: 1rem;
  }

  &__age-groups {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    font-size: 0.925rem;
    color: #707070;
    font-weight: bold;
    margin: 0.5rem 0 0;
    gap: 1rem;
  }

  &__age-group {
  }

  &__price {
    font-weight: bold;
    font-size: 1.125rem;
    font-family: var(--basket_price_font_family, inherit);
    font-weight: var(--basket_price_font_weight, bold);
    color: var(--basket_price_font_color, #236ca3);
  }

  &__block {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    flex-wrap: wrap;
    span {
      display: inline-block;
    }
  }

  &__block--no-end-date {
    max-width: 100%;
    justify-content: flex-start;
    gap: 1rem;
  }

  &__start_to {
    padding: 0 1rem;
  }
}

span.basket-item__start_date,
span.basket-item__end_date {
  display: flex;
  align-items: center;
}

@media screen and (max-width: 400px) {
  .basket-item__dates {
    gap: 0;
  }
  .basket-item__start_to,
  .basket-item__block span {
    font-size: 0.825rem;
  }
}

</style>
